import IssueCreateMessage from './IssueCreateMessage';

export default IssueCreateMessage;
